module.exports = ".background {\n    background-color: #F6F7FA;\n    height: 100vh;\n    width: 100vw;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.css
// module id = ./src/app/app.component.css
// module chunks = main